import candy from "url:../img/christmas/img_candy@2x.png"
import snow_flake from "url:../img/christmas/img_flake@2x.png"
import present from "url:../img/christmas/img_present@2x.png"
import snowman from "url:../img/christmas/img_snowman@2x.png"
import hat from "url:../img/christmas/img_hat@2x.png"
import santa from "url:../img/christmas/img_santa@2x.png"

const randomInRangeInt = (min, max) =>
  Math.floor(Math.random() * (max - min + 1)) + min

const FallingFlakes = () => {
  return (
    <div
      css={{
        zIndex: -1,
        position: "fixed",
        width: "100%",
      }}
    >
      <img
        src={hat}
        alt="Hat"
        style={{
          // transform: "rotate(-30deg)",
          position: "absolute",
          top: -32,
          left: `${randomInRangeInt(2, 7)}%`,
          width: 32,
          animation: "fall-presents 16s linear infinite",
          animationDelay: "2s",
        }}
      />
      <img
        src={candy}
        alt="Candy"
        style={{
          zIndex: 999,
          position: "absolute",
          top: -32,
          left: `${randomInRangeInt(5, 15)}%`,
          width: 30,
          animation: "fall-presents 12s linear infinite",
          animationDelay: "1s",
        }}
      />
      {[...Array(5)].map((_, i) => (
        <img
          key={i}
          src={snow_flake}
          alt="Snowflake"
          style={{
            position: "absolute",
            top: -26,
            left: `${randomInRangeInt(5, 30)}%`,
            width: randomInRangeInt(20, 26),
            animation: `fall ${10 + Math.random() * 10}s linear infinite`,
            animationDelay: `${Math.random() * randomInRangeInt(5, 10)}s`,
          }}
        />
      ))}
      {[...Array(5)].map((_, i) => (
        <img
          key={i}
          src={snow_flake}
          alt="Snowflake"
          style={{
            position: "absolute",
            top: -26,
            left: `${randomInRangeInt(70, 98)}%`,
            width: randomInRangeInt(20, 26),
            animation: `fall ${10 + Math.random() * 10}s linear infinite`,
            animationDelay: `${Math.random() * randomInRangeInt(5, 10)}s`,
          }}
        />
      ))}
      {[...Array(5)].map((_, i) => (
        <img
          key={i}
          src={snow_flake}
          alt="Snowflake"
          style={{
            position: "absolute",
            top: -26,
            left: `${randomInRangeInt(5, 30)}%`,
            width: randomInRangeInt(20, 26),
            animation: `fall ${10 + Math.random() * 10}s linear infinite`,
            animationDelay: `${Math.random() * 5}s`,
          }}
        />
      ))}
      {[...Array(5)].map((_, i) => (
        <img
          key={i}
          src={snow_flake}
          alt="Snowflake"
          style={{
            position: "absolute",
            top: -26,
            left: `${randomInRangeInt(70, 98)}%`,
            width: randomInRangeInt(20, 26),
            animation: `fall ${10 + Math.random() * 10}s linear infinite`,
            animationDelay: `${Math.random() * 5}s`,
          }}
        />
      ))}
      <img
        src={present}
        alt="Present"
        style={{
          zIndex: 999,
          position: "absolute",
          top: -35,
          left: `${randomInRangeInt(80, 95)}%`,
          width: 35,
          animation: "fall-presents 15s linear infinite",
          // animationDelay: "1s",
        }}
      />
      <img
        src={snowman}
        alt="Snowman"
        style={{
          position: "absolute",
          top: -40,
          left: `${randomInRangeInt(8, 20)}%`,
          width: 40,
          animation: "fall-presents 17s linear infinite",
          animationDelay: "1s",
        }}
      />
      <img
        src={santa}
        alt="Santa"
        style={{
          position: "absolute",
          top: -40,
          left: `${randomInRangeInt(90, 93)}%`,
          width: 40,
          animation: "fall-presents 16s linear infinite",
          // animationDelay: "1s",
        }}
      />
    </div>
  )
}

export default FallingFlakes
